import {
    OrganisationAccountingsModel,
    OrganisationAccountingsPayload,
    OrganisationAccountingsEntityTableName,
    ModelByOrganisationAccountingsEntityTable,
    PreparedDataOnOrganisationAccountingsUpdate,
} from '../../../../types/OrganisationAccountings';
import { UserModel } from '../../../../types/User';
import { ValidationOperation } from '../../../validation/validator';
import {
    addRelatedDataBatch,
    prepareUpdateUserFromPostPayload,
} from '../organisation/organisationUpdate';

const toPreparedDataItems = <K extends OrganisationAccountingsEntityTableName>(
    records: ModelByOrganisationAccountingsEntityTable[K][],
    table: K,
    operation: ValidationOperation,
) =>
    records.map((record) => ({
        record,
        table,
        operation,
    }));

const prepareUpdateOrganisationAccountings = ({
    orgElement,
    payload,
}: {
    orgElement: OrganisationAccountingsModel;
    payload: OrganisationAccountingsPayload;
}) =>
    orgElement.prepareUpdate((org) => {
        for (const key in payload) {
            org[key] = payload[key];
        }
    });

const appendPreparedOrganisationAccountings = (
    preparedData: PreparedDataOnOrganisationAccountingsUpdate[],
    organisationAccountings: OrganisationAccountingsModel,
) => [
    ...preparedData,
    ...toPreparedDataItems(
        [organisationAccountings],
        'organisation_accountings',
        'update',
    ),
];

const appendPreparedUser = (
    preparedData: PreparedDataOnOrganisationAccountingsUpdate[],
    user: UserModel,
) => [...preparedData, ...toPreparedDataItems([user], 'users', 'update')];

const logUpdateDBActions = ({
    orgElement,
    logDBAction,
    tableName,
    userUpdated,
    message = 'Update organisation accountings',
}: {
    orgElement: OrganisationAccountingsModel;
    logDBAction: (params: {
        message: string;
        modelName: string;
        payload: unknown;
    }) => void;
    tableName: string;
    userUpdated?: UserModel;
    message?: string;
}) => {
    logDBAction({
        message,
        modelName: tableName,
        payload: orgElement,
    });

    if (userUpdated) {
        logDBAction({
            message: 'Update user',
            modelName: 'users',
            payload: userUpdated,
        });
    }
};

export {
    addRelatedDataBatch,
    appendPreparedOrganisationAccountings,
    appendPreparedUser,
    logUpdateDBActions,
    prepareUpdateOrganisationAccountings,
    prepareUpdateUserFromPostPayload,
};
